<template>
  <div class="product-list">
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/technician/technician/add'">添加技师</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="name" label="姓名" width="150"></el-table-column>
        <el-table-column prop="image_url" label="照片" width="150">
          <template slot-scope="scope">
            <img v-img-url="'image.file_path',scope.row" width="100" height="100" />
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
        <el-table-column prop="experience_years" label="从业年限" width="100">
          <template slot-scope="scope">
            {{ scope.row.experience_years > 0 ? scope.row.experience_years + ' 年' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 10 ? 'success' : 'info'">
              {{ scope.row.status == 10 ? '在职' : '归档' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template #default="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/technician/technician/edit'">编辑</el-button>
            <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/technician/technician/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialog($event, 'add')"></Add>
    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" :subscription="subscription" @closeDialog="closeDialog($event, 'edit')"></Edit>

  </div>
</template>

<script>
import TechnicianApi from '@/api/technician/technician.js';
import SubscriptionApi from '@/api/subscription.js';
import Add from './Add.vue';
import Edit from './Edit.vue';
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*套餐额度信息*/
      subscription: {
        limit: 0,    // 总名额
        used: 0      // 当前在职人数
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
    /*获取套餐额度信息*/
    this.getSubscriptionInfo();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      TechnicianApi.getList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /**
     * 获取套餐额度信息
     * 使用 getSubscription 接口：limit = total_allowed_staff, used = active_technician_count
     */
    getSubscriptionInfo() {
      let self = this;
      SubscriptionApi.getSubscription({}, true)
        .then(data => {
          if (data.code === 1 && data.data && data.data.subscription) {
            const detail = data.data.subscription;
            const used = data.data.active_technician_count || 0;
            self.subscription = {
              limit: detail.total_allowed_staff || 0,
              used: used
            };
          }
        })
        .catch(error => {
          // 忽略错误，保持原有 subscription 值
        });
    },
    /**
     * 打开添加
     */
    addClick() {
      // 检查名额是否已满
      if (this.subscription.used >= this.subscription.limit) {
        this.showQuotaFullModal();
        return;
      }
      // 名额够，正常打开添加弹窗
      this.open_add = true;
    },
    /**
     * 打开编辑
     * @param {Object} item
     */
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
    /**
     * 删除
     * @param {Object} row
     */
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        TechnicianApi.del({id: row.id }, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              self.getData();
              self.getSubscriptionInfo();
            }
          }).catch(error => {
            self.loading = false;
          });
      }).catch(() => {
        self.loading = false;
      });
    },
    /**
     * 关闭弹窗
     * @param {Object} e
     * @param {string} type
     */
    closeDialog(e, type) {
      if (type == 'add') {
        this.open_add = false;
        if (e.type == 'success') {
          this.getData();
          this.getSubscriptionInfo();
        }
      } else if (type == 'edit') {
        this.open_edit = false;
        if (e.type == 'success') {
          this.getData();
          this.getSubscriptionInfo();
        }
      }
    },
    /**
     * 每页多少条
     * @param {number} val
     */
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /**
     * 翻页
     * @param {number} val
     */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },
    /**
     * 显示名额已满引导弹窗
     */
    showQuotaFullModal() {
      this.$confirm('当前套餐技师名额已满，无法添加或启用技师。<br>请购买额外名额，即买即用。', '名额不足', {
        confirmButtonText: '去购买名额',
        cancelButtonText: '暂不购买',
        type: 'warning',
        dangerouslyUseHTMLString: true // 允许换行
      }).then(() => {
        // 跳转到订阅管理页面，并自动切换到"购买名额"Tab
        this.$router.push({
          path: '/setting/subscription/index',
          query: { tab: 'addStaff' } // 传参，让它自动切到"购买名额"Tab
        });
      }).catch(() => {
        // 用户取消，不做任何操作
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/technician/technician/index.vue